import React from "react";

export default function Pagination({ page, limit, total, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const canPrev = page > 1;
  const canNext = page < totalPages;


  const buildPages = () => {
    const pages = [];
    const start = Math.max(1, page - 2);
    const end = Math.min(totalPages, page + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div>
        <small>Showing page {page} of {totalPages} — {total} records</small>
      </div>
      <div>
        <button className="btn btn-sm btn-outline-secondary me-1" disabled={!canPrev} onClick={() => onPageChange(page - 1)}>Prev</button>
        {buildPages().map(p => (
          <button key={p} className={`btn btn-sm ${p === page ? 'btn-primary' : 'btn-outline-secondary'} mx-1`} onClick={() => onPageChange(p)}>{p}</button>
        ))}
        <button className="btn btn-sm btn-outline-secondary ms-1" disabled={!canNext} onClick={() => onPageChange(page + 1)}>Next</button>
      </div>
    </div>
  );
}
